module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"loading":"読込中","no_data":"データがありません","processing":"解析中...","warning":{"list_row":"編集内容の反映に時間がかかっています。詳細を開いて操作を選択してください"}},"en":{"loading":"Now loading","no_data":"No data available","processing":"Processing...","warning":{"list_row":"The edit is taking longer than expected. Open the detail view to choose an action."}}}')
  delete Component.options._Ctor
}
